import { createContext, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { ErrorMessage, Spinner } from "app/components";
import { empresasService } from "app/services";
import { useContext } from "react";
import { useParams } from "react-router-dom";

const ActividadEconomicaContext = createContext();

const initialState = {
  actividad_economica_id: 0,
  actividad_economica_detalles: "",
  actividad_economica_principal: false,
};

export function ActividadEconomicaProvider({ children }) {
  const params = useParams();

  const [actividadEconomica, setActividadEconomica] = useState(initialState);
  const [isEditing, setEditing] = useState(false);

  const actividadEconomicaQuery = useQuery({
    queryKey: [
      "empresa:get:actividad_economica",
      params.empresa_id,
      params.actividad_id,
    ],
    queryFn: () =>
      empresasService.getActividadEconomica({
        empresaId: params.empresa_id,
        actividadId: params.actividad_id,
      }),
    onSuccess: (data) => {
      setActividadEconomica(data);

      setEditing(true);
    },
    enabled: !!params.actividad_id,
  });

  if (!!actividadEconomicaQuery.isLoading && !!params.actividad_id) {
    return <Spinner label="Cargando el actividad económica..." />;
  } else if (!!actividadEconomicaQuery.isFetching && !!params.actividad_id) {
    return <Spinner label="Recuperando el actividad económica..." />;
  } else if (!!actividadEconomicaQuery.isRefetching && !!params.actividad_id) {
    return <Spinner label="Recargando el actividad económica..." />;
  } else if (!!actividadEconomicaQuery.isError) {
    return (
      <ErrorMessage
        message={actividadEconomicaQuery.error.response.statusText}
      />
    );
  }

  return (
    <ActividadEconomicaContext.Provider
      value={{
        actividadEconomica,
        setActividadEconomica,
        isEditing,
      }}
    >
      {children}
    </ActividadEconomicaContext.Provider>
  );
}

export function useActividadEconomicaContext() {
  const actividad_economicaContext = useContext(ActividadEconomicaContext);

  if (!actividad_economicaContext) {
    throw new Error(
      "useActividadEconomicaContext should be used inside the ActividadEconomicaProvider."
    );
  }

  return actividad_economicaContext;
}
